import { ReactNode } from 'react'
import UserSignInContent from '../../components/user/UserSignInContent'
import UserSignInContentMobile from '../../components/user/UserSignInContentMobile'
import styles from '../../styles/user/UserSignInPage.module.scss'

interface SignInPageProps {
  children?: ReactNode
}

const UserSignIn = ({ children }: SignInPageProps) => {
  return (
    <div className={styles.pageWrapper}>
      {/* Background blobs */}
      <img src="/assets/login/background-5.svg" alt="" className={styles.topBg} />
      <img src="/assets/login/background-7.svg" alt="" className={styles.footerBg} />
      <img src="/assets/login/background-6.svg" alt="" className={styles.bottomRightBg} />
      <img src="/assets/login/background-8.svg" alt="" className={styles.bottomLeftBg} />

      {/* Deco elements */}
      <img src="/assets/login/deco-1.svg" alt="" className={styles.deco1} />
      <img src="/assets/login/deco-2.svg" alt="" className={styles.deco2} />
      <img src="/assets/login/deco-3.svg" alt="" className={styles.deco3} />
      <img src="/assets/login/deco-4.svg" alt="" className={styles.deco4} />
      <img src="/assets/login/deco-5.svg" alt="" className={styles.deco5} />
      <img src="/assets/login/deco-6.svg" alt="" className={styles.deco6} />

      {/* Header */}
      <header className={styles.pageHeader}>
        <img src="/assets/white-logo.svg" alt="Solution M" className={styles.logoImg} />
      </header>

      {/* Main content */}
      <div className={styles.mainContent}>
        <div className={styles.desktopOnly}>
          <UserSignInContent />
        </div>
        <div className={styles.mobileOnly}>
          <UserSignInContentMobile />
        </div>
      </div>
    </div>
  )
}

export default UserSignIn
